/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import * as React from "react";
import { DropdownColorPickerProps } from "./DropdownColorPicker.types";
import ColorPicker from "../ColorPicker/ColorPicker";
import DropDown from "../DropDown/DropDown";
import { BgColorIcon, FontColorIcon } from "../../../../assets/icons/SvgIcons";

export const DropdownColorPicker = ({
  disabled = false,
  stopCloseOnClickSelf = true,
  color,
  onChange,
  ...rest
}: DropdownColorPickerProps) => {
  const Icon =
    rest.iconName === "font" ? FontColorIcon : BgColorIcon;
  return (
    <DropDown
      {...rest}
      disabled={disabled}
      stopCloseOnClickSelf={stopCloseOnClickSelf}
      ButtonIcon={Icon}
      iconClassName="lexical-iconWrapper"
      container={document.getElementsByClassName("modal")[0] as HTMLElement}
    >
      <ColorPicker color={color} onChange={onChange} />
    </DropDown>
  );
};

export default DropdownColorPicker;
